export default __webpack_public_path__ + "static/media/page_context.5575250c.svg";